'use client'
import { jsx } from "react/jsx-runtime";
import { iconRegistry } from "@pcln/horizon-icons";
import { memo } from "react";
import { cn } from "../../utils/index.js";
import { cdnIconVariants } from "../CdnIcon/CdnIcon.variants.js";
const HorizonIcon = /*#__PURE__*/ memo(({ name, className, palette, shade, size, ...svgProps })=>{
    if (!name) return null;
    const IconComponent = iconRegistry[name];
    if (!IconComponent) throw new Error(`@pcln/horizon-icons//HorizonIcon: Icon ${name} not found`);
    const classes = cn(cdnIconVariants({
        palette,
        shade,
        size
    }), className);
    return /*#__PURE__*/ jsx("div", {
        className: classes,
        children: /*#__PURE__*/ jsx(IconComponent, {
            ...svgProps
        })
    });
});
export { HorizonIcon };
